import { render, staticRenderFns } from "./ReferralPage.vue?vue&type=template&id=139e7e3d&scoped=true"
import script from "./ReferralPage.vue?vue&type=script&lang=ts"
export * from "./ReferralPage.vue?vue&type=script&lang=ts"
import style0 from "./ReferralPage.vue?vue&type=style&index=0&id=139e7e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e7e3d",
  null
  
)

export default component.exports